import { createStructuredSelector } from "reselect";
import {
    USER_DETAIL,
    USER_DETAIL_SUCCESS,
    USER_DETAIL_ERROR
} from "../actions";

export const NAME = 'user';

export const UserDetail = (data) => ({
    type: USER_DETAIL,
    payload: data
});

export const UserDetailSuccess = (data) => ({
    type: USER_DETAIL_SUCCESS,
    payload: data
});

export const UserDetailError = (error) => ({
    type: USER_DETAIL_ERROR,
    payload: error
});

const user = (state) => state[NAME];

export const UserSelector = createStructuredSelector({
    user
})
